import { createContext } from 'react';

type UserProfile = {
  id: string;
  name: string;
  email: string;
};
export interface AuthenticationContextProps {
  tokenUserProfile: UserProfile | undefined;
  tokenRoles: string[];
  tokenSites: string[];
  getAccessToken: () => Promise<string>;
  logout: () => Promise<void>;
  login: () => Promise<void>;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AuthenticationContext = createContext<AuthenticationContextProps>(null!); // This will never be null
